import { ValidateJSModel } from 'forms/shared/types/validatejs';
import { isPVQForm } from 'helpers/form';
import { DEFAULT_LATEST } from 'constants/dateLimits';
import { foreclosureEntityTypes, foreclosurePropertyTypes } from 'constants/enums/financialOptions';
import pvqNameModelValidator from 'forms/shared/validators/models/pvqName/name';

import currencyModelValidator from 'forms/shared/validators/models/currency';
import { hasYesOrNo } from 'models/validate';
import locationUSAddressNoCountryModelValidator from 'forms/shared/validators/models/location/models/usAddressNoCountry';
import { FinancialForeclosureItemModel } from '../types';

export const financialForeclosureItemValidator: ValidateJSModel<FinancialForeclosureItemModel> = {
  EntityType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: foreclosureEntityTypes,
          }
        }
      };
    }

    return {};
  },

  EntityTypeExplain: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.EntityType?.value === 'Other') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  EntityName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && (attributes.EntityType?.value === 'Company' || attributes?.EntityType?.value === 'Government Agency')) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  PrivateName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.EntityType?.value === 'Individual') {
      return {
        presence: true,
        model: { validator: pvqNameModelValidator },
      };
    }

    return {};
  },
  PropertyType: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: {
          validator: {
            inclusion: foreclosurePropertyTypes,
          }
        }
      };
    }

    return {};
  },

  PropertyTypeExplain: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.PropertyType?.value === 'Other') {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  PropertyLocation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        location: {
          validator: locationUSAddressNoCountryModelValidator,
        },
      };
    }

    return {};
  },

  FirstPastDue: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      const { applicantBirthdate } = options;
      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }

    return {};
  },

  NumberMissed: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  AmountOwed: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        hasValue: true,
        model: {
          validator: currencyModelValidator,
        },
      };
    }

    return {};
  },

  Why: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  When: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      const { applicantBirthdate } = options;
      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }
    return {};
  },

  WhenEstimated: {},

  Current: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType)) {
      return {
        presence: true,
        hasValue: {
          validator: hasYesOrNo,
        },
      };
    }

    return {};
  },

  WhenResolved: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.Current?.value === 'No') {
      const { applicantBirthdate } = options;
      return {
        presence: true,
        date: { earliest: applicantBirthdate, latest: DEFAULT_LATEST },
      };
    }

    return {};
  },

  WhenResolvedEstimated: {},

  ActionsTaken: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.Current?.value === 'Yes' && attributes?.ActionsTakenNone?.applicable !== false) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  ActionsTakenReason: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.Current?.value === 'Yes' && attributes?.ActionsTakenNone?.applicable === false) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  CourtName: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.CourtNameNotApplicable?.applicable !== false) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  CourtNameNotApplicable: {},

  CourtLocation: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes?.CourtLocationNotApplicable?.applicable !== false) {
      // NOTE: due to over 20 states having Non-judicial foreclosures (not court involved) this is needed.
      return {
        presence: true,
        location: {
          validator: locationUSAddressNoCountryModelValidator
        },
      };
    }

    return {};
  },
  CourtLocationNotApplicable: {},

  OrderNum: (value, attributes, attributeName, options) => {
    if (isPVQForm(options?.formType) && attributes.OrderNumIdk?.applicable !== false) {
      return { presence: true, hasValue: true };
    }

    return {};
  },

  OrderNumIdk: {},
};
